import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Bell } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const NotificationBell = () => {
  const [count, setCount] = useState(0);

  const load = async () => {
    try {
      const r = await axios.get(`${API_URL}/api/notifications`, { withCredentials: true });
      setCount((r.data || []).filter((n) => !n.read).length);
    } catch (_) { /* ignore */ }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <Link
      to="/dashboard"
      className="relative inline-flex items-center justify-center w-9 h-9 rounded-md hover:bg-gray-100 transition-colors"
      data-testid="topbar-notif-bell"
      title="Notifications"
    >
      <Bell size={18} style={{ color: 'var(--dx-text2)' }} />
      {count > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full text-[10px] font-bold text-white"
          style={{ background: '#dc2626' }}
          data-testid="topbar-notif-count"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
};

export default NotificationBell;
